/// <reference path="ChangePassword.js" />
define('viewmodels/GeneralSettings',['knockout', 'plugins/router', 'durandal/app', 'services/appsecurity', 'services/navigation', 'durandal/system', 'services/logger'],
    function (ko, router, app, appsecurity, navigation, system, logger) {
        var CpViewModel = {
            activate: activate,
            attached: attached,
            appsecurity: appsecurity,
            ClientName: ko.observable(""),
            PageType: ko.observable("Screen"),
            ProfileList: ko.observableArray(),
            LanguageList: ko.observableArray(),
            getProfiles: getProfiles,
            getLanguages: getLanguages,
            ResetForm: ResetForm,
            SelectedProfile: ko.observable(""),
            SelectedLanguage: ko.observable(""),
            SelectedLanguageText: ko.observable('English'),
            SaveSettings: SaveSettings,
            //getLanguagesDictionary: getLanguagesDictionary,
            LanguageDictionary: ko.observableArray(),
            SettingTabclick: SettingTabclick,
            VerifyPhoneNumeber: VerifyPhoneNumeber,
            PhoneNumber: ko.observable(),
            OtpText: ko.observable(),
            OTPPassword: ko.observable(),
            SubmitOnetimepassword: SubmitOnetimepassword,
            ResendOTP: ResendOTP,
            Wrongattemptcount: ko.observable(3),
            ProviderName: ko.observable('SMSCode'),
            ClientsCount: ko.observable(1),
            LocalizedTextList: ko.observableArray([]),
            GetLocalizedData: GetLocalizedData,
            LocalizedIndexList: ko.observableArray([]),
            isNavigatedBackFromSurveyResponsePage: ko.observable(false),
            NavPillIdSurveyTracking: ko.observable(''),
            LocaleCheckFlag: ko.observable(false),
            SetContentWrapper: SetContentWrapper,
        };

        return CpViewModel;

        function activate() {
            try {

            }
            catch (e) {
                var msg = 'Exception' + e + ' Source | activate() in GeneralSettings.js';
                logger.logMessage(msg);
            }
        }

        function attached() {
            try {

                ResetForm();
                //getLanguagesDictionary();
                if (CpViewModel.appsecurity != undefined && CpViewModel.appsecurity.userInfo() != undefined) {

                    GetLocalizedData();
                }
            }


            catch (e) {
                var msg = 'Exception' + e + ' Source | attached() in GeneralSettings.js';
                logger.logMessage(msg);
            }
        }

        function SetContentWrapper(){
            if ($("#shellWrapper").hasClass('content-wrapper')) {
                $("#shellWrapper").removeClass('content-wrapper');
            }
            $("#shellWrapper").addClass("wrapper");
            $("#master-header-content").addClass("content-wrapper");
        }

        function ResetForm() {
            try {
                CpViewModel.ClientName("");
                getProfiles();
                getLanguages();
                GetProjectsList();

            }
            catch (e) {
                var msg = 'Exception' + e + ' Source | ResetForm() in ChangePassword.js';
                logger.logMessage(msg);
            }
        }

        
        function GetLocalizedData() {
            try {
                
                return $.ajax({
                    url: "/api/Configuration/GetLocalizationDetailsResx?LocaleCulture=" + CpViewModel.appsecurity.CurrentLocaletextOfUser(),
                    type: "GET",
                    async: false,
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetLocalizedData() method in LocalizationModule.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(jsonResult, status) {
                try {
                   
                    if (jsonResult.length == 0)
                        logger.logError('No records present for localized details.', 'Warning', system.getModuleId(CpViewModel), true);

                    for (var i = 0; i < jsonResult.length; i++) {
                        CpViewModel.LocalizedIndexList().push(jsonResult[i].Identifier);
                    }

                    var MappedGroupDetails = $.map(jsonResult, function (result) {
                        return new LocalizationModel(result);
                    });

                    CpViewModel.LocalizedTextList(MappedGroupDetails);
                    if (CpViewModel.LocalizedTextList() == undefined || CpViewModel.LocalizedTextList() == null || CpViewModel.LocalizedTextList().length <= 0 || CpViewModel.LocalizedIndexList() == undefined || CpViewModel.LocalizedIndexList() == null)
                        CpViewModel.LocaleCheckFlag(false);
                    else
                        CpViewModel.LocaleCheckFlag(true);

                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess from GetLocalizedData() method in LocalizationModule.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetLocalizedData() method in LocalizationModule.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail from GetLocalizedData() method in LocalizationModule.js';
                    logger.logMessage(msg);
                }
            }
        }
        function LocalizationModel(item) {
            try {
                var self = this;
                self.NameId = ko.observable(item.NameId);
                self.ClientId = ko.observable(item.ClientId);
                self.ClientName = ko.observable($('<div/>').html(item.ClientName).text());
                self.Name = ko.observable($('<div/>').html(item.Name).text());
                self.NameIdentifier = ko.observable($('<div/>').html(item.Identifier).text());
                self.LocaleId = ko.observable(item.LocaleId);
                self.Description = ko.observable($('<div/>').html(item.Description).text());
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: LocalizationModel() method in CalculationStatus.js';
                logger.logMessage(msg);
            }
        }


        function ProfileListModel(item) {
            try {
                var self = this;
                self.ProfileId = ko.observable(item.ID);
                self.ProfileName = ko.observable(item.PROFILE_NAME);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ProfileListModel() method in HeatMap.js';
                logger.logMessage(msg);
            }
        }


        function getProfiles() {
            try {

                $.ajax({
                    url: "/api/Account/GetProfiles",
                    type: "GET",
                    async: false,
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception' + e + 'Source: ajaxCall in GetProfiles() in GeneralSettings.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult != null && jsonResult.length > 0) {
                        var mappedProfiles = $.map(jsonResult, function (result) {
                            return new ProfileListModel(result);
                        });

                        CpViewModel.ProfileList(mappedProfiles);
                        CpViewModel.ClientName("Sample");
                    }
                }
                catch (e) {
                    var msg = 'Exception:' + e + '|Source : ajaxSuccess of GetProfiles() in GeneralSettings.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetProfiles() in GeneralSettings.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in  GetProfiles() in GeneralSettings.js';
                    logger.logMessage(msg);
                }
            }

        }

        function GetLanguagesModel(item) {
            try {
                var self = this;
                self.LANGUAGE_ID = ko.observable(item.LANGUAGE_ID);
                self.LANGUAGENAME = ko.observable(item.LANGUAGENAME);
                self.LOCALE = ko.observable(item.LOCALE);

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetLanguagesModel() method in GeneralSettings.js';
                logger.logMessage(msg);
            }
        }

        function getLanguages() {
            try {
                $.ajax({
                    url: "/api/Account/GetLanguages",
                    type: "GET",
                    async: false,
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception' + e + 'Source: ajaxCall in GetLanguages() in GeneralSettings.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult != null && jsonResult.length > 0) {
                        var mappedLanguages = $.map(jsonResult, function (result) {
                            return new GetLanguagesModel(result);
                        });
                        CpViewModel.LanguageList(mappedLanguages);
                    }
                }
                catch (e) {
                    var msg = 'Exception:' + e + '|Source : ajaxSuccess of GetLanguages() in GeneralSettings.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetLanguages() in GeneralSettings.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in  GetLanguages() in GeneralSettings.js';
                    logger.logMessage(msg);
                }
            }
        }

        function SaveSettings(data, event) {
            try {

                var selectedProfile = event.currentTarget.id;

                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Account/SaveSettings",
                    type: "POST",
                    headers: headers,
                    contentType: 'application/json',
                    data: ko.toJSON({
                        ID: selectedProfile,
                        LANGUAGE_ID: CpViewModel.appsecurity.CurrentLocaleOfUser()
                    })
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajax call from SaveSettings() method in GeneralSettings.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(jsonResult, status) {
                try {
                    if (status == 'success') {

                        logger.logSuccess('Assessment Period changed successfully.', 'Success', system.getModuleId(CpViewModel), true);
                        //getLanguagesDictionary();
                        GetLocalizedData();
                        CpViewModel.PageType("Screen");
                        CpViewModel.appsecurity.GetCurrentProfileOfAssessment();
                        CpViewModel.appsecurity.GetConfigurationFreezeFlag();
                        
                        var url = window.location.href,
                            suburl = url.substring(url.lastIndexOf('/') + 1);

                        if (suburl == 'Landing' || suburl == 'Landing#')
                            location.reload(true);
                        else {
                            router.navigate('Landing', true);
                            location.reload(true);
                        }

                    }
                    else {
                        //ResetForm();
                        logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(CpViewModel), true);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source:ajaxSuccess method in SaveSttings() method in GeneralSettings.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {

                    var msg = 'Exception: ' + error + ' | Source:ajaxFail method in SaveSttings() method in GeneralSettings.js';
                    logger.logMessage(msg);

                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source:ajaxFail method in SaveSttings() method in GeneralSettings.js';
                    logger.logMessage(msg);
                }
            }
        }



        //function getLanguagesDictionary() {
        //    var selectedText;
        //    $.each(CpViewModel.LanguageList(), function (i, obj) {
        //        if (obj.LANGUAGE_ID._latestValue == CpViewModel.SelectedLanguage())
        //            selectedText = obj.LANGUAGENAME._latestValue;
        //    });
        //    CpViewModel.SelectedLanguageText(selectedText);
        //    CpViewModel.LanguageDictionary([]);
        //    if (selectedText != null && selectedText != undefined && selectedText != "English") {
        //        try {
        //            $.ajax({
        //                url: "/api/Account/GetLanguagesList",
        //                type: "GET",
        //                data: { langId: CpViewModel.SelectedLanguage() },
        //                async: false,
        //                headers: appsecurity.getSecurityHeaders()
        //            })
        //                .success(ajaxSuccess)
        //                .fail(ajaxFail);
        //        }
        //        catch (e) {
        //            var msg = 'Exception' + e + 'Source: ajaxCall in getLanguagesDictionary() in GeneralSettings.js';
        //            logger.logMessage(msg);
        //        }
        //        function ajaxSuccess(jsonResult, status) {
        //            try {
        //                if (jsonResult != null && jsonResult.length > 0) {
        //                    //var mappedProfiles = $.map(jsonResult, function (result) {
        //                    //    return new ProfileListModel(result);
        //                    //});

        //                    CpViewModel.LanguageDictionary(jsonResult);
        //                    // logger.logSuccess(jsonResult, 'Success', "", true);

        //                }
        //            }
        //            catch (e) {
        //                var msg = 'Exception:' + e + '|Source : ajaxSuccess of getLanguagesDictionary() in GeneralSettings.js';
        //                logger.logMessage(msg);
        //            }
        //        }

        //        function ajaxFail(error, status) {
        //            try {
        //                if (error.status == 401) {
        //                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
        //                        .then(function (option) {
        //                            if (option == "OK")
        //                                navigation.unauthorized();
        //                        })
        //                }
        //                else {
        //                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in getLanguagesDictionary() in GeneralSettings.js';
        //                    logger.logMessage(msg);
        //                }
        //            }
        //            catch (e) {
        //                var msg = 'Exception: ' + e + ' | Source: ajaxFail in  getLanguagesDictionary() in GeneralSettings.js';
        //                logger.logMessage(msg);
        //            }
        //        }
        //    }
        //}


        function SettingTabclick(data, event) {
            try {
                if (event.currentTarget.id == "Profile") {
                    $('#profiledivshell').show();
                    $("#Enterphnodivshell   ").hide();
                    $('#SaveButton').show();
                    $('#verifyphno').hide();
                    $('#ValidateOTP').hide();
                    $('#ResendOTP').hide();
                    $('#SaveButton').show();
                }
                else {
                    $('#profiledivshell').hide();
                    $("#Enterphnodivshell").show();
                    $('#SaveButton').hide();
                    $('#verifyphno').show();
                    $('#ValidateOTP').hide();
                    $('#ResendOTP').hide();
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source:SettingTabclick() method in GeneralSettings.js';
                logger.logMessage(msg);
            }
        }

        function validphonenumber() {
            return true;
        }

        function VerifyPhoneNumeber(data, event) {
            try {
                $('#lodingimgphonenumber').show();
                if (validphonenumber()) {
                    $('#phonenumbervalidation').hide();
                    $('#Enterphnodivshell').show();
                    var Countrycode = $('.selected-flag').attr("title").split(":")[1].replace(" ", "")
                    var number = $("#numberprovider").val();
                    totalnumber = number.substring(Countrycode.length, number.length)
                    number = totalnumber
                    CpViewModel.PhoneNumber(Countrycode + "-" + number)
                    validatePhoneNumber(Countrycode, number);
                }
                else {
                    $('#lodingimgphonenumber').hide();
                    $('#phonenumbervalidation').show();
                    $('#Enterphnodivshell').show();
                    $('#phonenumbervalidation').html('Please enter a valid Phone Number.')
                }
                //  CreateOneTimePassword()
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: VerifyPhoneNumeber() method in AuthorizeMFA.js';
                logger.logMessage(msg);
            }
        }

        function validatePhoneNumber(Countrycode, number) {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;

                $.ajax({
                    url: "/api/Account/ValidatePhoneNumber",
                    type: "POST",
                    headers: headers,
                    contentType: 'application/json',
                    data: JSON.stringify
                        ({
                            Countrycode: Countrycode,
                            number: number
                        })
                })
                    .success(function (jsonResult, status) {
                        var totallength = number.substring(number.length - 3, number.length);
                        var countrycode = Countrycode + "-" + number.substring(0, 2);
                        var completenumber = countrycode + "*****" + totallength;
                        $('#lodingimgphonenumber').hide();
                        $('#AuthenticateDivshellphch').show();
                        $("#Enterphnodivshell").hide();
                        $('#profiledivshell').hide();
                        $('#SaveButton').hide();
                        $('#verifyphno').hide();
                        $('#ValidateOTP').show();
                        $('#ResendOTP').show();

                        CpViewModel.OtpText('We\'ve sent you a text message on ' + completenumber + " with a verificatin code.")
                    })
                    .fail(function (error, status) {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in NavigatetoClientSpeceficPage() method in ProjectAuthorizeMFA.js';
                        logger.logMessage(msg);
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: validatePhoneNumber() method in AuthorizeMFA.js';
                logger.logMessage(msg);
            }
        }

        function SubmitOnetimepassword() {
            try {
                $('#lodingimgphonenumber').show();
                $('#AuthenticateDivshellphch').hide();
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;

                $.ajax({
                    url: "/api/Account/ValidateOTP",
                    type: "POST",
                    headers: headers,
                    contentType: 'application/json',

                    data: JSON.stringify
                        ({
                            ProviderName: CpViewModel.ProviderName(),
                            PhoneNumber: CpViewModel.PhoneNumber(),
                            Isverfiedphonenumber: false,
                            Token: CpViewModel.OTPPassword(),

                        })
                })
                    .success(function (jsonResult, status) {
                        if (jsonResult == true) {
                            $('#lodingimgphonenumber').hide();
                            $('#AuthenticateDivshellphch').hide();
                            CpViewModel.Wrongattemptcount(3);
                            $('#frmGeneralSettings').modal('hide');
                            $('body').removeClass('modal-open');
                            $('.modal-backdrop').remove();
                            //router.navigate('ProjectLanding');
                            logger.logSuccess('OTP has been successfully verified.', 'Success', system.getModuleId(CpViewModel), true);
                            logger.logSuccess('Phone Number has been changed succesfully.', 'Success', system.getModuleId(CpViewModel), true);
                        }
                        else {

                            $('#lodingimgphonenumber').hide();
                            CpViewModel.Wrongattemptcount(CpViewModel.Wrongattemptcount() - 1)
                            $('#OTPValidationshellcn').show();
                            if (CpViewModel.Wrongattemptcount() == 2) {
                                logger.logWarning('Please enter a valid OTP.', 'Warning', system.getModuleId(CpViewModel), true);
                                $('#OTPValidationshellcn').html(CpViewModel.Wrongattemptcount() + ' more attempts left.');
                            }

                            else if (CpViewModel.Wrongattemptcount() == 1) {
                                logger.logWarning('Please enter a valid OTP.', 'Warning', system.getModuleId(CpViewModel), true);
                                $('#OTPValidationshellcn').html(CpViewModel.Wrongattemptcount() + ' more attempt left.');
                            }
                            else if (CpViewModel.Wrongattemptcount() == 0) {
                                logger.logWarning('You have exceeded max. number of failure attempts.', 'Warning', system.getModuleId(CpViewModel), true);
                                $('#OTPValidationshellcn').html('You have exceeded max. number of failure attempts. Please login back.');
                                CpViewModel.appsecurity.logout()
                                    .done(function (token) {
                                        $("input[name='__RequestVerificationToken']").val(token);
                                        appsecurity.clearAuthInfo();
                                        window.location = routeconfig.login;
                                    })
                                    .fail(function (error) {
                                        appsecurity.clearAuthInfo();
                                        window.location = routeconfig.login;
                                    });
                            }

                        }

                    })
                    .fail(function (error, status) {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in NavigatetoClientSpeceficPage() method in ProjectAuthorizeMFA.js';
                        logger.logMessage(msg);
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SubmitOnetimepassword() method in AuthorizeMFA.js';
                logger.logMessage(msg);
            }
        }
        function ResendOTP() {
            try {
                SubmitOnetimepassword();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ResendOTP() method in AuthorizeMFA.js';
                logger.logMessage(msg);
            }
        }
    });

